import { useState } from 'react';
import { IoClose } from "react-icons/io5";

import Input from "../../../../../../Atoms/Input";
import Loader from "../../../../../../Atoms/Loader";

export default function RenameModal({ isOpen, onClose, onConfirm, currentName, isLoading }) {
    const [newName, setNewName] = useState(currentName || '');

    if (!isOpen) return null;

    const handleConfirm = async () => {
        await onConfirm(newName);
        setNewName('');
    };

    const handleCancel = () => {
        setNewName('');
        onClose();
    };

    const handleModalClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div 
            className="modal show d-block" 
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            onClick={handleModalClick}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ backgroundColor: '#1E1E1E', border: '1px solid #314158' }}>
                    <div className="modal-header border-0 d-flex justify-content-between align-items-center">
                        <h5 className="modal-title text-white">Renomear arquivo</h5>
                        <button
                            type="button"
                            className="btn text-white"
                            onClick={handleCancel}
                            style={{ fontSize: '24px', padding: 0, lineHeight: 1 }}
                        >
                            <IoClose />
                        </button>
                    </div>
                    <div className="modal-body">
                        <Input
                            type="text"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            placeholder="Digite o novo nome..."
                            style={{ 
                                width: '100%',
                                backgroundColor: '#27272A',
                                color: 'white',
                                border: '1px solid #314158',
                                borderRadius: '8px',
                                padding: '12px'
                            }}
                        />
                    </div>
                    <div className="modal-footer border-0">
                        {isLoading ? (
                            <Loader/>    
                        ) : (
                            <>
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={handleCancel}
                                >
                                    Cancelar
                                
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleConfirm}
                                    style={{
                                        backgroundColor: '#8E51FF',
                                        border: 'none'
                                    }}
                                >
                                    Confirmar
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
